module.exports = __webpack_public_path__ + "img/ps-calentamiento.b7fd7ad0.jpg";